import { createSelector } from '@reduxjs/toolkit';

const ipi = (state) => state || {};

export const getIPIData = createSelector(ipi, (state) => state?.importantInfo?.ipiData);
export const getIPILoaded = createSelector(ipi, (state) => state?.importantInfo?.ipiLoaded);
